/** WARNING: This file is generated automatically **/

import type { TrackingContextValue } from '../providers/TrackingContext';
import { getEntities } from '../utils/getEntities';
import { getGTMData } from '../utils/getGTMData';
import { trackSelfDescribingEvent } from '../utils/trackSelfDescribingEvent';

/**
 * triggers when the user is presented with search results
 */
export interface ResultsView {
  /**
   * the value the user typed in and triggered the list of results
   */
  userInput: string;
  /**
   * list of results. if the results are games, send them as seperate entities
   *
   * @minItems 1
   */
  valueList?: [string, ...string[]] | null;
  /**
   * total number of results that are returned from the search
   */
  totalResults: number;
}

export const resultsView = (data: Readonly<ResultsView>, context?: TrackingContextValue) => {
  window.__GTM_DATA_LAYER__?.push({ event: 'results_view', ...data, ...getGTMData(context) });

  trackSelfDescribingEvent(
    {
      event: {
        schema: 'iglu:com.starsgroup/results_view/jsonschema/2-0-0',
        data
      },
      context: getEntities(context)
    },
    context
  );
};
